// The two ways an admin can order the transfers inside a quotation.
// Must match BOOKING_SORT_ORDER in routes/utils/sortQuotationBookings.js (backend),
// which is where the actual sorting rule lives.
export const BOOKING_SORT_ORDER = {
  TRAVEL_DATE: "travelDate",
  ADDED_AT: "addedAt",
};

// Returns a NEW array with the bookings placed in the same order as `sortedBookingIds`
// (the order the backend sent back after saving). A booking whose id is not in the
// list keeps its place at the end, so nothing ever disappears from the page.
export const orderBookingsByIds = (bookings, sortedBookingIds) => {
  if (!Array.isArray(bookings)) return [];
  if (!Array.isArray(sortedBookingIds)) return [...bookings];

  const getPosition = (booking) => {
    const position = sortedBookingIds.indexOf(String(booking?._id));
    return position === -1 ? sortedBookingIds.length : position;
  };

  return [...bookings].sort(
    (bookingA, bookingB) => getPosition(bookingA) - getPosition(bookingB)
  );
};
